import src from "IMAGE";
export default { src, width: 1440, height: 980, blurWidth: 0, blurHeight: 0};
